const Cache = Object.create(null);
const useValueService = (hooks) => {
    const { enableValueCache } = hooks.dataTableOptions;
    hooks.useInstance.push((instance) => {
        const getCacheKey = (row, colId) => {
            return `${row.id}__${colId}`;
        };
        const setValue = (row, colId, value) => {
            if (enableValueCache) {
                const cacheKey = getCacheKey(row, colId);
                Cache[cacheKey] = {
                    data: value,
                    value: row.values[colId],
                };
            }
        };
        const getValue = (row, colId) => {
            const cacheKey = getCacheKey(row, colId);
            const cachedData = Cache[cacheKey];
            if (!cachedData) {
                return undefined;
            }
            if (!enableValueCache) {
                return undefined;
            }
            return cachedData;
        };
        const valueGetter = (row, column) => {
            const { id, valueGetter } = column;
            if (!id || id === 'row-menu-column' || id === 'selection') {
                return undefined;
            }
            const cachedData = getValue(row, id);
            if (cachedData && cachedData.value !== undefined && row.values[id] === cachedData.value) {
                return cachedData.data;
            }
            const result = valueGetter ? valueGetter(row) : row.values[id];
            if (result !== undefined) {
                setValue(row, id, result);
            }
            return result;
        };
        Object.assign(instance, {
            valueService: {
                setValue,
                getValue,
                valueGetter,
            },
        });
    });
};

export { useValueService as default };
//# sourceMappingURL=useValueService.js.map
